import type { IsoDate } from "./IsoDate"

export function isIsoDate(date?: unknown): date is IsoDate {
	return typeof date === "string" && /\d{4}-[01]\d-[0-3]\d/.test(date)
}
